import { React, useState, forwardRef, useImperativeHandle } from "react";
import DropZone from "components/DropZone/Dropzone";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import { ArchivoManager } from "managers/archivo.manager";

const DocumentoUploader = forwardRef((
  {
    showLoading,
    hideLoading,
    modulo,
    fuente,
    referencia,
    maxFiles,
    multiple = false,
    label = "Haga click o arrastre archivos para subir",
    archivosLabel = "Archivos subidos",
    typeFiles = "",
    onChange = () => { }
  },
  ref
) => {
  const [files, setFiles] = useState([]);
  const { Message } = useMessage();
  const { handleException } = useExceptionHandler();

  const onFileChange = (list) => {
    setFiles(list);
    onChange(list);
  };

  const grabar = () => {
    showLoading();
    ArchivoManager.adjuntarDocumentos({
      Fuente: fuente,
      Modulo: modulo,
      Referencia: referencia,
      Files: files,
    })
      .then(() => {
        Message({ message: "Grabado Exitosamente" });
      })
      .catch((e) => handleException(e));
  };

  useImperativeHandle(ref, () => ({
    grabar,
  }));

  return (
    <>
      <DropZone
        multiple={multiple}
        label={label}
        updateFilesCb={onFileChange}
        maxFiles={maxFiles}
        ArchivosLabel={archivosLabel}
        type={typeFiles}
        showFiles={true}
      />
    </>
  );
}
);

export default DocumentoUploader;
